import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Fade, Button, InputAdornment, Box } from '@material-ui/core'
import { FormLoader } from '../../../Loader/FormLoader'
import { formStyles } from '../FormStyles'
import { InvoiceItemsProvider, InvoiceItemsConsumer } from '../../../../context/InvoiceItemsContext'
import ItemsList from './ItemsList'
import FormTextField from '../../../../FormFields/FormTextField'
import taxTypes from '../../../../configurations/tax-types'
import nonTaxableTaxTypes from '../../../../configurations/non-taxable-tax-types'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined'
import { CreateInvoiceStep3FormValidation } from '../../../../utils/validationSchema'
import Alert from '@material-ui/lab/Alert'
import AddNewDialog from '../../../Dialog/AddNewDialog'
import { LanguageConsumer } from '../../../../context/LanguageContext'
import InvoiceCreateStep2 from '../Step2'
import { AuthConsumer } from '../../../../context/AuthContext'
import SaveInvoiceBtn from '../../SaveInvoiceBtn'

const InvoiceCreateStep3 = ({ invoiceData, onSubmit, hasReferences, currencies, updateCurrenciesList, handleBackStep, locale, handleSaveInvoiceEntity, savedTemplateData, invoicePersonalLimit, isCopyInvoice }) => {
  const formClasses = formStyles()
  const [personalLimitDialogOpen, setPersonalLimitDialogOpen] = React.useState(false)
  const [personalLimitDialogView, setPersonalLimitDialogView] = React.useState(false)
  const handlePersonalLimitDialog = () => {
    if (!personalLimitDialogOpen) {
      setPersonalLimitDialogView(true)
    } else {
      invoiceStep3Form.setSubmitting(false)
      setTimeout(() => setPersonalLimitDialogView(false), 500)
    }
    setPersonalLimitDialogOpen(!personalLimitDialogOpen)
  }
  const invoiceStep3Form = useFormik({
    initialValues: (!!Object.keys(invoiceData?.step3 || {}).length) ? invoiceData.step3 : {
      documentType: invoiceData?.step1?.documentType || '',
      invoiceLines: [],

      calculatedTotalSalesAmount: 0,
      calculatedTotalSalesAmountEGP: 0,
      totalSalesAmountEdit: false,
      totalSalesAmount: 0,

      calculatedTotalDiscountAmount: 0,
      calculatedTotalDiscountAmountEGP: 0,
      totalDiscountAmountEdit: false,
      totalDiscountAmount: 0,

      calculatedNetAmount: 0,
      calculatedNetAmountEGP: 0,
      netAmountEdit: false,
      netAmount: 0,

      calculatedTotalItemsDiscountAmount: 0,
      calculatedTotalItemsDiscountAmountEGP: 0,
      totalItemsDiscountAmountEdit: false,
      totalItemsDiscountAmount: 0,

      taxTotals: [],

      extraDiscountAmount: 0,

      calculatedTotalAmount: 0,
      calculatedTotalAmountEGP: 0,
      totalAmountEdit: false,
      totalAmount: 0,
      originTotalAmount: invoiceData?.step3?.totalAmount || ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    validationSchema: CreateInvoiceStep3FormValidation,
    onSubmit: ((values, actions) => {
      if (invoiceData?.step2?.receiverType === 'P' && !!invoicePersonalLimit && parseFloat(invoiceStep3Form.values.calculatedTotalAmountEGP) >= parseFloat(invoicePersonalLimit) &&
        (!invoiceData?.step2?.receiverID ||
          !invoiceData?.step2?.receiverName ||
          !Object.keys(invoiceData?.step2?.receiverAddress || {}).length
        )) {
        handlePersonalLimitDialog()
      } else {
        onSubmit(values, actions, 'step3')
      }
    })
  })
  let allTaxes = [...taxTypes, ...nonTaxableTaxTypes]
  return (
    <Fade in={true}>
      <>
        {!!personalLimitDialogView &&
        <AddNewDialog
          children={<AuthConsumer>
            {({ taxpayerData }) => (
              <LanguageConsumer>
                {({ locale }) => (
                  <InvoiceCreateStep2
                    taxpayerData={taxpayerData}
                    locale={locale}
                    invoiceData={invoiceData}
                    itemsAmount={invoiceStep3Form.values.totalAmount}
                    onSubmit={(values, actions, key) => {
                      onSubmit(values, actions, key, null, handlePersonalLimitDialog)
                      setTimeout(() => onSubmit(invoiceStep3Form.values, invoiceStep3Form, 'step3'), 500)
                    }}
                    inDialog
                    handlePersonalLimitDialog={handlePersonalLimitDialog}
                    handleBackStep={handleBackStep}/>
                )}
              </LanguageConsumer>
            )}
          </AuthConsumer>}
          DialogTitle={<FormattedMessage id='invoice.step3.personalLimitData.dialogTitle'/>}
          isDialogOpen={personalLimitDialogOpen}
          cancelDialog={handlePersonalLimitDialog}
        />
        }

        <InvoiceItemsProvider listArr={invoiceData?.step3?.invoiceLines || []} formActions={invoiceStep3Form}
                              currencies={currencies}>
          <InvoiceItemsConsumer>
            {({
                cancelDialog, currentSelectedRow, dialogActionSubmit, handleChangeListingPage, listingLoading,
                handleChangeListingRowsPerPage, isDialogOpen, listingCount, listingData, listingPage, currentCurrency, sameCurrency,
                listingRowsPerPage, openDialog, currentDialogAction, calculateAllLinesValues, isDialogView,
                handleSwitchEditChange, DecimalBlur, DecimalChange, netAmountEdit, setNetAmountEdit, setTaxEdit,
                totalDiscountAmountEdit, setTotalDiscountAmountEdit, totalAmountEdit, setTotalAmountEdit
              }) => (
              <form onSubmit={invoiceStep3Form.handleSubmit} noValidate autoComplete="off"
                    className={formClasses.formWrapper}>
                {!!hasReferences && invoiceData?.step1?.documentType &&
                <Alert severity="warning" className={formClasses.alert}>
                  <FormattedMessage id={`InvoicesReference.items.AlertHint.${invoiceData?.step1?.documentType}`}
                                    values={{
                                      strong: chunks => <strong>{chunks}</strong>
                                    }}/>
                </Alert>
                }
                <ItemsList currentSelectedRow={currentSelectedRow} dialogActionSubmit={dialogActionSubmit}
                           hasReferences={hasReferences} handleChangeListingPage={handleChangeListingPage}
                           currentDialogAction={currentDialogAction} listingLoading={listingLoading}
                           handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                           isDialogOpen={isDialogOpen} listingCount={listingCount} listingData={listingData}
                           documentType={invoiceData?.step1?.documentType} isDialogView={isDialogView}
                           listingPage={listingPage} listingRowsPerPage={listingRowsPerPage} openDialog={openDialog}
                  // updateParentEntity={(value) => {
                  //   console.log('end', invoiceStep3Form.values)
                  //   // calculateAllLinesValues(value)
                  // }}
                           formClasses={formClasses} cancelDialog={cancelDialog} locale={locale}
                           currencies={currencies} updateCurrenciesList={updateCurrenciesList}
                           currentCurrency={currentCurrency} sameCurrency={sameCurrency}/>


                {!!listingCount &&
                <div className={formClasses.FormTotals}>

                  {/*<FormTextField name={'totalSalesAmount'} labelKey={'Fields.label.totalSalesAmount'}*/}
                  {/*               classes={formClasses}*/}
                  {/*               switchEdit switchEditValue={totalSalesAmountEdit}*/}
                  {/*               handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalSalesAmountEdit, 'totalSalesAmount')}*/}
                  {/*               formActions={invoiceStep3Form}*/}
                  {/*               onChange={(event) => DecimalChange(event, 'totalSalesAmount')}*/}
                  {/*               onBlurFn={(event) => DecimalBlur(event, 'totalSalesAmount')}*/}
                  {/*               InputAttributes={{*/}
                  {/*                 startAdornment: <InputAdornment position="start">*/}
                  {/*                   {invoiceStep3Form.values.currency}*/}
                  {/*                 </InputAdornment>*/}
                  {/*               }}/>*/}

                  {/*<FormTextField name={'totalDiscountAmount'}*/}
                  {/*               labelKey={'Fields.label.totalDiscountAmount'}*/}
                  {/*               classes={formClasses}*/}
                  {/*               switchEdit switchEditValue={totalDiscountAmountEdit}*/}
                  {/*               handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalDiscountAmountEdit, 'totalDiscountAmount')}*/}
                  {/*               formActions={invoiceStep3Form}*/}
                  {/*               onChange={(event) => DecimalChange(event, 'totalDiscountAmount')}*/}
                  {/*               onBlurFn={(event) => DecimalBlur(event, 'totalDiscountAmount')}*/}
                  {/*               InputAttributes={{*/}
                  {/*                 startAdornment: <InputAdornment position="start">*/}
                  {/*                   {invoiceStep3Form.values.currency}*/}
                  {/*                 </InputAdornment>*/}
                  {/*               }}/>*/}

                  <FormTextField name={'netAmount'}
                                 labelKey={'Fields.label.netAmount'}
                                 classes={formClasses}
                                 switchEdit={!hasReferences} switchEditValue={netAmountEdit}
                                 handleSwitchEdit={(value) => handleSwitchEditChange(value, setNetAmountEdit, 'netAmount')}
                                 formActions={invoiceStep3Form}
                                 disabled={!!hasReferences && invoiceData?.step1?.documentType}
                                 onChange={(event) => DecimalChange(event, 'netAmount')}
                                 onBlurFn={(event) => DecimalBlur(event, 'netAmount')}
                                 InputAttributes={{
                                   startAdornment: <InputAdornment position="start">
                                     {currentCurrency?.key}
                                   </InputAdornment>
                                 }}/>

                  <FormTextField name={'totalDiscountAmount'}
                                 labelKey={'Fields.label.totalDiscountAmount'}
                                 classes={formClasses}
                                 switchEdit={!hasReferences} switchEditValue={totalDiscountAmountEdit}
                                 handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalDiscountAmountEdit, 'totalDiscountAmount')}
                                 disabled={!!hasReferences && invoiceData?.step1?.documentType}
                                 formActions={invoiceStep3Form}
                                 onChange={(event) => DecimalChange(event, 'totalDiscountAmount')}
                                 onBlurFn={(event) => DecimalBlur(event, 'totalDiscountAmount')}
                                 InputAttributes={{
                                   startAdornment: <InputAdornment position="start">
                                     {currentCurrency?.key}
                                   </InputAdornment>
                                 }}/>

                  {/*<FormTextField name={'totalItemsDiscountAmount'}*/}
                  {/*               labelKey={'Fields.label.totalItemsDiscountAmount'}*/}
                  {/*               classes={formClasses}*/}
                  {/*               switchEdit={!hasReferences} switchEditValue={totalItemsDiscountAmountEdit}*/}
                  {/*               handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalItemsDiscountAmountEdit, 'totalItemsDiscountAmount')}*/}
                  {/*               disabled={!!hasReferences && invoiceData?.step1?.documentType}*/}
                  {/*               formActions={invoiceStep3Form}*/}
                  {/*               onChange={(event) => DecimalChange(event, 'totalItemsDiscountAmount')}*/}
                  {/*               onBlurFn={(event) => DecimalBlur(event, 'totalItemsDiscountAmount')}*/}
                  {/*               InputAttributes={{*/}
                  {/*                 startAdornment: <InputAdornment position="start">*/}
                  {/*                   {currentCurrency?.key}*/}
                  {/*                 </InputAdornment>*/}
                  {/*               }}/>*/}


                  {!!invoiceStep3Form.values.taxTotals?.length && invoiceStep3Form.values.taxTotals.map(tax => {
                    let taxObj = allTaxes.filter(item => item.key?.toString() === tax.taxType?.toString())
                    return <FormTextField key={tax.taxType}
                                          name={tax.taxType}
                                          label={taxObj?.length ? `${taxObj[0][`name_view_${locale}`]} (${tax.taxType})` : ''}
                                          classes={formClasses}
                                          value={tax.amount}
                                          switchEdit={!hasReferences} switchEditValue={tax.amountEdit}
                                          handleSwitchEdit={(value) => handleSwitchEditChange(value, setTaxEdit, tax.taxType, true)}
                                          disabled={!!hasReferences && invoiceData?.step1?.documentType}
                                          formActions={invoiceStep3Form}
                                          onChange={(event) => DecimalChange(event, tax.taxType, true)}
                                          onBlurFn={(event) => DecimalBlur(event, tax.taxType, true)}
                                          InputAttributes={{
                                            startAdornment: <InputAdornment position="start">
                                              {currentCurrency?.key}
                                            </InputAdornment>
                                          }}/>
                  })}

                  <FormTextField name={'extraDiscountAmount'} labelKey={'Fields.label.extraDiscountAmount'}
                                 classes={formClasses}
                                 formActions={invoiceStep3Form}
                                 disabled={!!hasReferences && invoiceData?.step1?.documentType}
                                 onChange={(event) => DecimalChange(event, 'extraDiscountAmount')}
                                 onBlurFn={(event) => DecimalBlur(event, 'extraDiscountAmount')}
                                 InputAttributes={{
                                   startAdornment: <InputAdornment position="start">
                                     {currentCurrency?.key}
                                   </InputAdornment>
                                 }}/>

                  <FormTextField name={'totalAmount'}
                                 labelKey={'Fields.label.totalAmount'}
                                 classes={formClasses}
                                 switchEdit={!hasReferences} switchEditValue={totalAmountEdit}
                                 handleSwitchEdit={(value) => handleSwitchEditChange(value, setTotalAmountEdit, 'totalAmount')}
                                 disabled={!!hasReferences && invoiceData?.step1?.documentType}
                                 originValue={!!isCopyInvoice ? null : invoiceData?.step3?.totalAmount}
                                 formActions={invoiceStep3Form}
                                 onChange={(event) => DecimalChange(event, 'totalAmount')}
                                 onBlurFn={(event) => DecimalBlur(event, 'totalAmount')}
                                 InputAttributes={{
                                   startAdornment: <InputAdornment position="start">
                                     {currentCurrency?.key}
                                   </InputAdornment>
                                 }}
                                 specialError={['C', 'EC'].includes(invoiceData?.step1?.documentType) &&
                                 (parseFloat(invoiceStep3Form?.values.totalAmount) > parseFloat(invoiceData?.step3?.totalAmount)) &&
                                 <FormattedMessage id='validationSchema.exceedOriginValue'/>}/>

                </div>
                }
                <Box px={1} mb={3} className={formClasses.FormSubmitRow + ' between'}>
                  <Button variant={'outlined'} size={'large'} color={'secondary'}
                          className={formClasses.InvoiceStepGoBack} onClick={handleBackStep}>
                    {locale === 'ar' ? <ArrowForwardIosOutlinedIcon/> : <ArrowBackIosOutlinedIcon/>}
                    <FormattedMessage id='requestStep.button.previous'/>
                  </Button>
                  <div>
                    <SaveInvoiceBtn
                      disabled={!!invoiceStep3Form.isSubmitting || !invoiceStep3Form.isValid || (['C', 'EC'].includes(invoiceData?.step1?.documentType) &&
                        (parseFloat(invoiceStep3Form?.values.totalAmount) > parseFloat(invoiceData?.step3?.totalAmount)))}
                      savedTemplateData={savedTemplateData}
                      handleSaveInvoiceEntity={(e, entityType, tempData, formikActions, closeDialog) => handleSaveInvoiceEntity(e, entityType,
                        invoiceStep3Form.values, 'step3', tempData, formikActions, closeDialog)}/>

                    <Button type={'submit'} variant={'contained'} size={'large'} color={'secondary'}
                            onClick={invoiceStep3Form.handleSubmit}
                            disabled={invoiceStep3Form.isSubmitting || !invoiceStep3Form.isValid || (['C', 'EC'].includes(invoiceData?.step1?.documentType) &&
                              (parseFloat(invoiceStep3Form?.values.totalAmount) > parseFloat(invoiceData?.step3?.totalAmount)))}
                    >
                      <FormattedMessage id='invoiceSteps.button.submit'/>
                      {locale === 'ar' ? <ArrowBackIosOutlinedIcon/> : <ArrowForwardIosOutlinedIcon/>}
                    </Button>
                  </div>
                </Box>
                {!!invoiceStep3Form.isSubmitting && <FormLoader loading={true}/>}
              </form>

            )}
          </InvoiceItemsConsumer>
        </InvoiceItemsProvider>
      </>
    </Fade>
  )
}

export default InvoiceCreateStep3
